var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "breakdown-chart" },
    [
      _c("div", { staticClass: "bc-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.rows && _vm.rows.length > 0
          ? _c(
              "div",
              { staticClass: "bc-body" },
              [
                _c("ECharts", {
                  staticClass: "bc-graph",
                  attrs: { option: _vm.option },
                }),
              ],
              1
            )
          : !_vm.loading
          ? _c("div", { staticClass: "bc-empty" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("metaInsights.noBreakdownData")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }